import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { S3_BUCKET_URL } from '@/constants';
import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import {
  DominateOptionItemSprite,
  DominateOptionItemSpriteList,
} from '@/pages/Onboarding/Layouts/OwnAI_Dominate/components/DominateOptionItemSprite';
import { TOOLS_OPTIONS } from '@/pages/Onboarding/options/Tools/TOOLS_OPTIONS';
import { ToolsOptionIdType } from '@/pages/Onboarding/options/Tools/types';
import { getToolsChoiceTitleById } from '@/pages/Onboarding/options/Tools/utils/getToolsChoice';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { PageStyles } from './Tools.styles';

export const ScreenTools: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Tools',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const tools = form.watch('tools');

  const handleSelect = (option: OnbOptionType<LayoutDataType['tools']>) => {
    form.setValue('tools', option.id);
  };

  const getImageSrc = (id: OnbOptionType<ToolsOptionIdType>['id']) => {
    return `${S3_BUCKET_URL}/layout-own-ai-dominate-v2/tools/${id}.png`;
  };

  const handleNextStep = () => {
    userService.createOrUpdate({
      onboarding_data: {
        tools: getToolsChoiceTitleById(tools),
      },
    });
    wizard.nextStep();
  };

  return (
    <PageStyles background={'domination'}>
      <OnboardingNavigation />
      <OwnAiTitle>
        I enjoy playing with my toys.
        <br />
        You get one choice — make it count
      </OwnAiTitle>

      <IonContent>
        <DominateOptionItemSpriteList>
          {TOOLS_OPTIONS.map((option) => (
            <DominateOptionItemSprite
              key={option.id}
              alt="tools"
              isSelected={tools === option.id}
              onClick={() => handleSelect(option)}
              spriteSrc={getImageSrc(option.id)}
              title={option.title}
              subtitle={option.subtitle}
              TEST_ID={`tools-${option.id}`}
            />
          ))}
        </DominateOptionItemSpriteList>
      </IonContent>

      {tools && (
        <OnboardingFooter
          onContinue={handleNextStep}
          buttonColor={'red-gradient'}
          buttonRadius={'sm'}
          buttonSize={'medium'}
          buttonText="I'll follow"
        />
      )}
    </PageStyles>
  );
};
